// extracted by mini-css-extract-plugin
export default {"contentAuthor":"PracticesTable_contentAuthor__dG7H8","root":"PracticesTable_root__-5l-g"};